<template>
  <v-row>
    <UserInfoSideBar />
    <v-container justify-start>
      <v-row>
        <span class="font-weight-black text-h6 mt-7 ml-10">お気に入りトピック一覧</span>
      </v-row>
      <template v-if="loading">
        <v-row justify="center" align-content="center" class="mt-10">
          <img src="../../../assets/loading.gif">
        </v-row>
      </template>
      <template>
        <v-row class="mt-5 mx-12" v-if="isExistTopic">
          <v-col
              v-for="(item, i) in topics"
              :key="i"
          >
            <v-card
              class="mx-auto mt-0 d-flex flex-column"
              width="306"
              height="369"
              outlined
            >
              <router-link :to="{ name: 'topic', params: { topic_code: item.topic_code }}" style="text-decoration: none;">
                <v-img
                  class="white--text align-end"
                  style="height:170px"
                  :src="`${bucketUrl}${item.topic_image_url}`"
                >
                </v-img>
              </router-link>
              <router-link
                :to="{ name: 'user', params: { user_code: item.user_code } }"
                style="text-decoration: none; color: inherit"
              >
                <v-card-subtitle class="pb-2  user-title">
                  <v-avatar size="24" depressed>
                    <v-img :src="item.icon_url" width="24" height="24"></v-img>
                  </v-avatar>
                  <span class="ml-2 font-weight-bold">{{ item.user_name }}</span>
                </v-card-subtitle>
              </router-link>
              <v-card-text class="pt-0 overflow-auto">
                <router-link :to="{ name: 'topic', params: { topic_code: item.topic_code }}" 
                  class="font-weight-bold pt-0 mb-2"
                  style="
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                    text-decoration: none;
                    color: black;
                  "
                >{{ item.topic_name }}</router-link>
                <span v-for="tag in item.tags" :key="tag.tag_name" class="mr-2">
                  <v-btn
                    depressed
                    dark
                    color="#333333"
                    @click="searchTag(tag.tag_name)"
                    x-small
                    class="font-weight-bold tag-name"
                    style="text-transform: none"
                  >{{ tag.tag_name }}</v-btn>
                </span>
              </v-card-text>
              <v-spacer></v-spacer>
              <v-divider class=""></v-divider>
              <v-card-actions>
                <div class="text-caption">更新日：{{ formatDate(item.updated_at) }}</div>
                <div class="text-caption ml-auto">
                  <v-icon>mdi-heart</v-icon>
                  {{ item.lgtm }}
                </div>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-else>
          <p class="ml-10 mt-5">お気に入りしたトピックはありません</p>
        </v-row>
      </template>
    </v-container>
  </v-row>
</template>
<script>
import dayjs from "dayjs";
import UserInfoSideBar from '../../organisms/UserInfoSideBar'

export default {
  name: 'FavoriteTopicsList',
  components :{
    UserInfoSideBar,
  },
  data() {
    return {
      loading: true,
      drawer: true,
      user: {},
      topics: [],
      user_code: '',
      total_count: null,
      bucketUrl: process.env.VUE_APP_IMAGE_BUCKET_URL,
      isExistTopic: true,
    }
  },
  created: function () {
    this.user_code = this.$store.getters['auth/isUserCode']
    this.$store.dispatch('favorite/topics')
      .then(() => {
        this.topics = this.$store.getters['favorite/topics'];
        this.total_count = this.topics.length;
        if (this.total_count === 0) {
          this.isExistTopic = false;
        }
      });
    this.loading = false;
  },
  computed: {
    icon: function() {
      return this.user.icon_url
    },
  },
  methods: {
    formatDate: dateStr => dayjs(dateStr).format('YYYY/MM/DD'),
  },
}
</script>
<style scoped>
.user-title:hover {
  background-color: #F4F4F4;
}
.tag-name:hover {
  color: #C388FF;
}
</style>